export const errorMessages = Object.freeze({
  WRONG_VALUE: 'Wprowadzona wartość jest niepoprawna',
  REQUIRED: 'Wypełnij wymagane pola',
  TOO_LONG: 'Wprowadzona wartość jest za długa',
  TOO_SHORT: 'Wprowadzona wartość jest za krótka',
  FORMAT: 'Wprowadzona wartość jest w złym formacie',
  PASSWORDS_DO_NOT_MATCH: 'Wprowadzone wartości nie pasują do siebie',
  MISSING_CONSENTS: 'Zapoznaj się i zaakceptuj wymagane zgody',
  GENERAL: 'Coś poszło nie tak. Spróbuj ponownie później.'
})

export const validateRequired = (value) => !value
export const validatePattern = (pattern, value) => value && !pattern.test(value)

export const formValidator = {
  validateRequired (value) {
    if (validateRequired(value)) {
      return errorMessages.REQUIRED
    }
  },

  validateEmail (value, isRequired = false) {
    const reg = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i

    if (isRequired && this.validateRequired(value)) {
      return errorMessages.REQUIRED
    }

    if (validatePattern(reg, value)) {
      return errorMessages.FORMAT
    }
  },

  validatePassword (password, confirmationPassword, isRequired = false) {
    const MIN_PASSWORD_LENGHT = 8

    if (isRequired && this.validateRequired(password)) {
      return errorMessages.REQUIRED
    }

    if (password.length < MIN_PASSWORD_LENGHT) {
      return `${errorMessages.TOO_SHORT}. Minimalna długość hasła to ${MIN_PASSWORD_LENGHT} znaków`
    }

    if (password !== confirmationPassword) {
      return errorMessages.PASSWORDS_DO_NOT_MATCH
    }
  }
}
